import { render, staticRenderFns } from "./tipovi-motora.editor.vue?vue&type=template&id=3fde02d8&"
import script from "./tipovi-motora.editor.vue?vue&type=script&lang=ts&"
export * from "./tipovi-motora.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports